import React from "react";
import LearingPathList from "./learningPathList";


const Dashboard = () => {
  return (
    <div className="mylearningpaths">
    <div>
      <LearingPathList />
    </div>
    </div>
  );
}

export default Dashboard;